export const GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
export const GET_SURVEY_ERROR = 'GET_SURVEY_ERROR';

export const SAVE_ANSWER_REQUEST = 'SAVE_ANSWER_REQUEST';
export const SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';
export const SAVE_ANSWER_ERROR = 'SAVE_ANSWER_ERROR';

export const RESET_BLOCK_SURVEY = 'RESET_BLOCK_SURVEY';

const block = {
  loading: false,
  success: false,
  error: null,
};

const initialState = {
  surveys: null,
  getSurvey: { ...block, loading: true },
  saveAnswer: { ...block },
};

export const SurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURVEY_REQUEST:
      return {
        ...state,
        getSurvey: { ...state.getSurvey, loading: true },
      };
    case GET_SURVEY_SUCCESS:
      return {
        ...state,
        getSurvey: {
          ...state.getSurvey,
          loading: false,
          success: true,
          error: null,
        },
        surveys: action.data,
      };
    case GET_SURVEY_ERROR:
      return {
        ...state,
        getSurvey: {
          ...state.getSurvey,
          loading: false,
          error: action.error,
        },
      };
    case SAVE_ANSWER_REQUEST:
      return {
        ...state,
        saveAnswer: { ...state.saveAnswer, loading: true },
      };
    case SAVE_ANSWER_SUCCESS:
      return {
        ...state,
        saveAnswer: {
          ...state.saveAnswer,
          loading: false,
          success: true,
          error: null,
        },
      };
    case SAVE_ANSWER_ERROR:
      return {
        ...state,
        saveAnswer: {
          ...state.saveAnswer,
          loading: false,
          error: action.error,
        },
      };
    case RESET_BLOCK_SURVEY:
      return { ...state, [action.block]: { ...state[action.block], ...block } };
    default:
      return state;
  }
};
